module.exports = __webpack_public_path__ + "img/TopState2R.7619e985.png";